import fetchServiceTypes from '../../../Core/Services/fetchServiceTypes';
import fetchItemDescriptions from '../Services/fetchItemDescriptions';

export default () => async (dispatch) => {
  
  await dispatch(fetchServiceTypes());
  dispatch(fetchItemDescriptions());
  
}